/* ShelfStory Advertorial — JavaScript v2
   Features: Sticky bar, smooth scroll, image fade-in, Shopify AJAX Add to Cart */
(function() {
  'use strict';

  /* ── Sticky Add-to-Cart Bar ──────────────────────────────── */
  var stickyBar = document.querySelector('.ss-sticky-bar');
  if (stickyBar) {
    var showThreshold = 400;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          if (window.scrollY > showThreshold) {
            stickyBar.classList.add('ss-sticky-bar--visible');
          } else {
            stickyBar.classList.remove('ss-sticky-bar--visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Smooth Scroll for Learn More ────────────────────────── */
  var learnMoreBtn = document.querySelector('.ss-learn-more-btn');
  if (learnMoreBtn) {
    learnMoreBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.getElementById('article-start');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ── Image Fade-In on Scroll ─────────────────────────────── */
  var images = document.querySelectorAll('.ss-article-img img');
  if (images.length > 0 && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    images.forEach(function(img) {
      img.style.opacity = '0';
      img.style.transform = 'translateY(20px)';
      img.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(img);
    });
  }

  /* ── Shopify AJAX Add to Cart ────────────────────────────── */
  var atcBtn = document.getElementById('ss-sticky-atc');
  if (atcBtn) {
    atcBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = atcBtn.getAttribute('data-variant-id');
      var textEl = document.getElementById('ss-sticky-atc-text');

      /* If no variant ID configured, fall back to product page */
      if (!variantId || variantId === '') {
        var productUrl = document.querySelector('[data-product-url]');
        if (productUrl) {
          window.location.href = productUrl.getAttribute('data-product-url');
        } else {
          /* Fallback: find first CTA link on page */
          var ctaLink = document.querySelector('.ss-cta-btn');
          if (ctaLink) {
            window.location.href = ctaLink.getAttribute('href');
          }
        }
        return;
      }

      /* Show loading state */
      atcBtn.disabled = true;
      if (textEl) textEl.textContent = 'Adding...';

      /* Shopify AJAX Cart API */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1
          }]
        })
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Add to cart failed');
        }
        return response.json();
      })
      .then(function(data) {
        /* Success — show confirmation then redirect to cart */
        if (textEl) textEl.textContent = 'Added!';
        atcBtn.style.background = '#5A8A3C';
        atcBtn.style.borderColor = '#5A8A3C';

        setTimeout(function() {
          window.location.href = '/cart';
        }, 800);
      })
      .catch(function(error) {
        /* Error — reset button and redirect to product page as fallback */
        console.error('ShelfStory ATC Error:', error);
        if (textEl) textEl.textContent = 'Add to Cart';
        atcBtn.disabled = false;

        /* Fallback to product page */
        var fallbackUrl = 'https://shopshelfstory.com/products/library-of-books-diy-book-nook-kit';
        var ctaLink = document.querySelector('.ss-cta-btn');
        if (ctaLink) fallbackUrl = ctaLink.getAttribute('href');
        window.location.href = fallbackUrl;
      });
    });
  }
})();
